import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/atoms/Button';
import { getFormattedDistance } from '@/utils/Common/Utils';

const GoogleMarker = ({ store, t }) => (
  <div className='dln-mapPopup'>
    <div className='dln-mapPopup__head'>
      <h3 className='dln-mapPopup__company'>{store.displayName}</h3>
      <p className='dln-mapPopup__distance'>
        {getFormattedDistance(store.formattedDistance)}
      </p>
    </div>
    <div className='dln-mapPopup__wrap dln-mapPopup__wrap--info '>
      <p className='dln-mapPopup__data'>
        {store.address.line1}
        {store.address.line2 && <>,&nbsp;{store.address.line2}</>}
      </p>
      <p className='dln-mapPopup__data'>{store.address.town}</p>
      <p className='dln-mapPopup__data'>
        {store.address.region && store.address.region.name && (
          <>{store.address.region.name},&nbsp;</>
        )}
        {!store.address.region && store.address.district && (
          <>{store.address.district},&nbsp;</>
        )}
        {store.address.postalCode}
      </p>
      <p className='dln-mapPopup__data'>
        {store.address.country ? store.address.country.name : ''}
      </p>
      {store.address.phone && (
        <p className='dln-mapPopup__data'>
          {t('storeFinder:store.finder.marker.phone')}{' '}
          <a href={`tel:${store.address.phone}`}>
            <strong>{store.address.phone}</strong>
          </a>
        </p>
      )}
    </div>
    {store.openingHours && (
      <div className='dln-mapPopup__wrap dln-mapPopup__wrap--hours'>
        {store.openingHours.weekDayOpeningList.map(opening => (
          <p
            key={opening.weekDay}
            className='dln-mapPopup__data dln-mapPopup__data--brand-02'
          >
            {t(`storeFinder:store.finder.hour.${opening.weekDay}`)}{' '}
            {opening.closed
              ? t('storeFinder:store.finder.hour.closed')
              : `${opening.openingTime.formattedHour} - ${opening.closingTime.formattedHour}`}
          </p>
        ))}
      </div>
    )}
    <div className='dln-mapPopup__wrap dln-mapPopup__wrap--actions'>
      {store.address.url && (
        <Button
          onClick={() => {}}
          modifiers={['stroked', 'website']}
          text={t('storeFinder:store.finder.marker.website')}
          id={`js-r-website-${store.name}`}
        />
      )}
      {store.address.email && (
        <Button
          onClick={() => {}}
          modifiers={['stroked', 'writeUs']}
          text={t('storeFinder:store.finder.marker.write.us')}
          id={`js-r-write-${store.name}`}
        />
      )}
      <Button
        onClick={() => {}}
        text={t('storeFinder:store.finder.marker.maps')}
        modifiers={['stroked', 'googleMaps']}
        id={`js-r-maps-${store.name}`}
      />
    </div>
    <span className='dln-mapPopup__triangle' />
  </div>
);

GoogleMarker.propTypes = {
  store: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default GoogleMarker;
